/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import api from '@/lib/api';

export const getPricingTiers = () => api.get('/pricing/tiers').then(r => r.data);
export const getMyPricingStatus = () => api.get('/pricing/my-status').then(r => r.data);
export const declareIsee = (isee_value, consent = true, self_declared = true) =>
  api.post('/pricing/isee/declare', { isee_value, consent, self_declared }).then(r => r.data);
export const clearIsee = () => api.delete('/pricing/isee').then(r => r.data);
export const subscribeFamily = (bundle_id, members = []) =>
  api.post('/pricing/family/subscribe', { bundle_id, members }).then(r => r.data);
export const unsubscribeFamily = () => api.delete('/pricing/family').then(r => r.data);
export const createFamilyCheckout = (bundle_id, members = [], origin_url = window.location.origin) =>
  api.post('/pricing/family/checkout', { bundle_id, members, origin_url }).then(r => r.data);
export const getFamilyDashboard = () =>
  api.get('/pricing/family/dashboard').then(r => r.data);
export const assignToFamilyMember = (kind, resource_id, member_key) =>
  api.post('/pricing/family/assign', { kind, resource_id, member_key }).then(r => r.data);
export const getPricingQuote = (base_price = 30) =>
  api.get('/pricing/quote', { params: { base_price } }).then(r => r.data);

// ---- ISEE Attestazione verification (Sprint 9F) ----
export const uploadIseeAttestazione = (file_base64, filename, mime_type = 'application/pdf') =>
  api.post('/pricing/isee/attestazione/upload', { file_base64, filename, mime_type }).then(r => r.data);
export const deleteIseeAttestazione = () =>
  api.delete('/pricing/isee/attestazione').then(r => r.data);

// ---- Admin ----
export const adminIseeQueue = (status = 'pending') =>
  api.get('/admin/pricing/isee-queue', { params: { status } }).then(r => r.data);
export const adminGetAttestazione = (userId) =>
  api.get(`/admin/pricing/isee/${userId}/attestazione`).then(r => r.data);
export const adminVerifyIsee = (userId, action, note = null) =>
  api.post(`/admin/pricing/isee/${userId}/verify`, { action, note }).then(r => r.data);

// ---- Utility ----
export const fileToBase64 = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => resolve(String(reader.result || ''));
  reader.onerror = () => reject(new Error('Impossibile leggere il file'));
  reader.readAsDataURL(file);
});
